import { HISTORY_TYPES, IHistoryItem } from 'types/History';

export const formatClaimHistory = (items: IHistoryItem[]): IHistoryItem[] => {
	return items
		.flatMap<IHistoryItem>(item => {
			if (item.typeHistory === HISTORY_TYPES.COMPLAINT) {
				const children: IHistoryItem[] = [];

				if (item.outcomeCode) {
					children.push({
						...item,
						statusCode: undefined,
						typeCode: undefined,
					});
				}

				if (item.typeCode) {
					children.push({
						...item,
						statusCode: undefined,
						outcomeCode: undefined,
					});
				}

				if (item.statusCode) {
					children.push({
						...item,
						outcomeCode: undefined,
						typeCode: undefined,
					});
				}

				if (children.length > 0) {
					return children;
				}
			}

			return [item];
		})
		.sort(
			(a, b) =>
				new Date(b.lastInsert).getTime() - new Date(a.lastInsert).getTime(),
		);
};
